import angular from 'angular';
import EventEmitter from 'utility/event-emitter';
import * as devices from '../../../../modules/devices';
import { OTPublisherErrors } from 'providers/video/tokbox/tokbox-video-provider.class';
export class EnableCameraErrorHandler extends EventEmitter {
    constructor(notificationFactory, Browser, $translate, $ngRedux) {
        super();
        this.notificationFactory = notificationFactory;
        this.Browser = Browser;
        this.$translate = $translate;
        this.$ngRedux = $ngRedux;
    }
    onCommon(err) {
        this.log(err);
        if (this.Browser.isMobileScreen()) {
            this.$ngRedux.dispatch(devices.actions.mediaAccessDenied());
        }
        else {
            this.checkNotAllowed(err);
            this.checkUsedByOtherApp(err);
        }
    }
    onPatientCheckIn(err) {
        this.log(err);
        this.checkNotAllowed(err);
        this.checkUsedByOtherApp(err);
    }
    log(err) {
        if (err.name) {
            console.error(`Enable webcam: [${err.name}] ${err.message}`);
        }
    }
    checkNotAllowed(err) {
        if (err.name === OTPublisherErrors.NotAllowedError) {
            this.notificationFactory.showUnsafeMessage('error', this.$translate.instant('media-access.no-media.desktop-message', {
                articleUrl: this.Browser.getHelpArticleUrl(),
            }), 'user-media-access-denied-notification', 30000);
        }
    }
    checkUsedByOtherApp(err) {
        if (['AbortError', 'NotReadableError'].includes(err.name)) {
            this.notificationFactory.showUnsafeMessage('error', this.$translate.instant('media-access.no-media.camera-blocked-by-other-application'), 'user-media-access-denied-notification', 30000);
        }
    }
}
export default angular
    .module('doxy.providers.video.common.services.enableCameraErrorHandler', [])
    .service('enableCameraErrorHandler', EnableCameraErrorHandler).name;
